import { Outlet } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';

interface PublicLayoutProps {
  showFooter?: boolean;
}

export function PublicLayout({ showFooter = true }: PublicLayoutProps) {
  return (
    <div className="min-h-screen bg-cream flex flex-col">
      {/* Header with auth buttons */}
      <Header showAuth showNav={false} />

      {/* Main content */}
      <main className="flex-1">
        <Outlet />
      </main>

      {/* Footer */}
      {showFooter && <Footer />}
    </div>
  );
}
